// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  apiUrl: 'your-api-url.com',
  version: '1.0.1',
  firebase: {
    apiKey: 'AIzaSyASxqJWK4pjMsojWB3XyrLmWJJXDPGve1c',
    authDomain: 'parceiro-poty.firebaseapp.com',
    databaseURL: 'https://parceiro-poty.firebaseio.com',
    projectId: 'parceiro-poty',
    storageBucket: 'parceiro-poty.appspot.com',
    messagingSenderId: '714160100667',
    appId: '1:714160100667:web:068fcaf2938840506fd31e',
    measurementId: 'G-BWEH3QZ99S',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
